import {
    BaseBoxShapeUtil,
    HTMLContainer,
    RecordProps,
    T,
    TLBaseShape,
    stopEventPropagation,
    TLResizeHandle,
} from 'tldraw'
import {TaskStatusType} from "../types/taskFlow.types";
import CircularProgress from "@mui/material/CircularProgress";
import {TaskLoading} from "../icons";


type IMyEditableShape = TLBaseShape<
    'dialog-shape',
    {
        text: string,
        status: string,
        h: number,
        w: number,
        loading: boolean
        taskId: number,
        imageData?: string[],
        cover?: boolean
    }
>

export class DialogShapeUtil extends BaseBoxShapeUtil<IMyEditableShape> {
    static override type = 'dialog-shape' as const
    static override props: RecordProps<IMyEditableShape> = {
        text: T.string,
        status: T.string,
        w: T.number,
        h: T.number,
        loading: T.boolean,
        taskId: T.number,
        imageData: T.any,
        cover: T.any
    }


    getDefaultProps(): IMyEditableShape['props'] {
        return {
            text: '对【蛇元素】和【新中式】进行发散联想',
            status: '待确认',
            w: 260,
            h: 400,
            loading: true,
            taskId: 0,
            imageData: undefined
        }
    }

    // 禁用调整大小功能
    override canResize = (_shape: IMyEditableShape) => {
        return false
    }

    // 隐藏调整大小的控制点
    override hideResizeHandles = (_shape: IMyEditableShape): boolean => {
        return true
    }

    // [2]
    component(shape: IMyEditableShape) {
        // [a]
        const isEditing = this.editor.getEditingShapeId() === shape.id

        return (
            <HTMLContainer
                id={shape.id}
                // [b]
                onPointerDown={isEditing ? stopEventPropagation : undefined}
                style={{
                    pointerEvents: isEditing ? 'all' : 'none',
                }}
            >
                <div style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: "column",
                    alignItems: "end",
                    padding: '10px'
                }}>
                    <div style={{
                        position: 'relative',
                        padding: '10px',
                        borderRadius: 6, 
                        backgroundColor: '#DDE2FF',
                        display: shape.props.text ? 'inline-block' : 'none',
                        maxWidth: '100%',
                        color: '#444444',
                        whiteSpace: "pre-wrap",
                        lineHeight: "25px",
                        fontFamily: "monospace"
                    }}>
                        {shape.props.text}
                        <div style={{
                            position: 'absolute',
                            right: '-8px',
                            top: '6px',
                            width: 0,
                            height: 0,
                            borderTop: '8px solid transparent',
                            borderBottom: '8px solid transparent',
                            borderLeft: '8px solid #DDE2FF'
                        }}></div>
                    </div>
                    {
                        shape.props.imageData?.map((img, index) => (
                            <div key={index} style={{
                                position: 'relative',
                                marginTop: 10,
                                padding: '10px',
                                borderRadius: 6,
                                backgroundColor: '#DDE2FF',
                                height: '340px',
                                display: shape.props.imageData?.length ? 'block' : 'none'
                            }}>
                                <img width='100%' height='100%' style={{objectFit: 'cover', opacity: shape.props.cover ? 0 : 1}}
                                     src={`${process.env.REACT_APP_PROXY_TARGET}${img}`} alt=''/>
                                <div style={{
                                    position: 'absolute',
                                    right: '-8px',
                                    top: '10px',
                                    width: 0,
                                    height: 0,
                                    borderTop: '8px solid transparent',
                                    borderBottom: '8px solid transparent',
                                    borderLeft: '8px solid #DDE2FF'
                                }}></div>
                            </div>
                        ))
                    }
                </div>
            </HTMLContainer>
        )
    }

    indicator(shape: IMyEditableShape) {
        // 返回固定大小的indicator
        return <rect width={shape.props.w} height={shape.props.h}/>
    }
}